import React from 'react';
import { Button, Row, Col, Pagination, Tag, Tooltip, Empty } from 'antd';
import { EditOutlined, DeleteOutlined, StarOutlined, StarTwoTone } from '@ant-design/icons';
import { PRODUCT } from '../../../shared/types/productType';

import Loading from '../../../shared/components/Loading/Index'

export default function ResultList(props) {
    return (
        <Loading visible={props.pagination.loading} text='Un momento por favor.'>
            <Row style={{ minHeight: '250px', margin: '0px -10px 0px -10px' }}>
                {
                    props.pagination.items.length === 0 ?
                        <div className='vertical-center horizontal-center'>
                            <Empty description='No se encontraron datos' />
                        </div> :
                        props.pagination.items.map(item => (
                            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4} key={item.id}>
                                <div style={{ padding: '10px' }}>
                                    <div className='catalog-card-content'>
                                        <div className='catalog-card-item'>
                                            <div className="vertical-center h-100">
                                                <img src={item.images[0]} alt="card" />
                                            </div>
                                        </div>
                                        <div className='catalog-card-info'>

                                            <div className="flex-parent">
                                                <div className="flex-child long-and-truncated">
                                                    <div className='ml-5'>
                                                        <Tooltip title={item.name}>
                                                            <div className='catalog-card-title'>{item.name}</div>
                                                        </Tooltip>

                                                        <div>S/. {item.price.toFixed(2)}</div>
                                                        <div className='catalog-card-freshipping'>
                                                            {
                                                                item.freeShipping ?
                                                                    <Tag style={{ marginTop: '6px', marginRight: '0px' }} color="green">Envío Gratis</Tag> : null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex-child short-and-fixed">
                                                    <Tooltip title='Eliminar'>
                                                        <Button danger
                                                            type="text"
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => props.onDelete(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title='Modificar'>
                                                        <Button
                                                            type="text"
                                                            onClick={() => props.onEdit(item)}
                                                            icon={<EditOutlined style={{ color: '#606060' }} />}
                                                        />
                                                    </Tooltip>
                                                    {
                                                        item.productType === PRODUCT ?
                                                            <Tooltip title={item.highlighted ? 'Quitar Descatado' : 'Destacar'}>
                                                                <Button
                                                                    type="text"
                                                                    onClick={() => props.onHighlighted(item)}
                                                                    icon={item.highlighted ? <StarTwoTone /> : <StarOutlined style={{ color: '#606060' }} />}
                                                                />
                                                            </Tooltip> : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))
                }
            </Row>
            <Row justify='end'>
                <Pagination
                    className='mt-10'
                    size='small'
                    defaultCurrent={1}
                    total={props.pagination.total}
                    current={props.pagination.page}
                    showSizeChanger={false}
                    responsive={true}
                    pageSize={props.pagination.size}
                    onChange={(page, size) => props.onPagination({ ...props.pagination, page, size })}
                    showTotal={(total) => `${total} Registro(s) encontrado(s).`}
                />
            </Row>
        </Loading>
    );
}